const appConfig = {
  baseRoute: process.env.NODE_ENV === 'production' ? '/' : '/',//'npm run build': NODE_ENV = 'production' , npm run start: NODE_ENV = 'development'
  testMode: false
};

export default appConfig;
